import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogActions, DialogContent, DialogHeader, DialogTitle } from "~/common/mui";
import { PackagingSelection } from "~/domains/product/components/PackagingSelection/PackagingSelection";
import type { PackagingOption } from "~/domains/product/types/PackagingOption";

interface SelectPackagingDialogProps {
  open: boolean;
  onClose: () => void;
  selectedPackCode: string;
  options: PackagingOption[];
  onSelectPackCode: (packCode: string) => void;
}

export const SelectPackagingDialog = ({
  open,
  onClose,
  selectedPackCode,
  options,
  onSelectPackCode,
}: SelectPackagingDialogProps) => {
  const { t } = useTranslation();
  const [internalSelectedPackCode, setInternalSelectedPackCode] = useState(selectedPackCode);
  useEffect(() => {
    setInternalSelectedPackCode(selectedPackCode);
  }, [selectedPackCode]);

  const handleConfirm = () => {
    onSelectPackCode(internalSelectedPackCode);
    onClose();
  };
  return (
    <Dialog open={open} onClose={onClose} maxWidth="desktop-s">
      <DialogHeader onClose={onClose}>
        <DialogTitle sx={{ p: 0 }}>{t("cartPage.table.content.choosePackaging")}</DialogTitle>
      </DialogHeader>
      <DialogContent>
        <PackagingSelection value={internalSelectedPackCode} onChange={setInternalSelectedPackCode} options={options} />
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onClose}>
          {t("cancel")}
        </Button>
        <Button onClick={handleConfirm}>{t("common.select")}</Button>
      </DialogActions>
    </Dialog>
  );
};
